import React, { useState, useEffect, useRef } from "react";
import {
  collection,
  getDocs,
  onSnapshot,
  deleteDoc,
  doc,
  updateDoc,
  query,
  where
} from "firebase/firestore";
import { db } from "../../firebase"; // Import your Firebase configuration
import { Modal, Button, Form, Alert } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../style/FacilityTable.css";
import "../style/Admin.css";

export default function AdminUserTable() {
  let unsubscribe;

  const [merchants, setMerchants] = useState([]);
  const [filteredMerchants, setFilteredMerchants] = useState([]);
  const [searchMerchantName, setSearchMerchantName] = useState("");
  const [searchMerchantEmail, setSearchMerchantEmail] = useState("");
  // const [filterType, setFilterType] = useState("");
  const [sortType, setSortType] = useState("asc");
  const [currentPage, setCurrentPage] = useState(1);
  const merchantsPerPage = 10;
  const [showModal, setShowModal] = useState(false);
  const [selectedMerchantDetails, setSelectedMerchantDetails] = useState(null);
  const [shownDescription, setShownDescription] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [merchantToDelete, setMerchantToDelete] = useState(null);
  const [merchantNameToDelete, setMerchantNameToDelete] = useState(null);
  const [editingMerchant, setEditingMerchant] = useState(null);
  const [showEditModal, setShowEditModal] = useState(null);
  const indexOfLastMerchant = currentPage * merchantsPerPage;
  const indexOfFirstMerchant = indexOfLastMerchant - merchantsPerPage;
  const merchantsToShow = filteredMerchants.slice(
    indexOfFirstMerchant,
    indexOfLastMerchant
  );
  const nameRef = useRef();
  const emailRef = useRef();
  const contactRef = useRef();
  const [name, setName] = useState("");
  const [contact, setContact] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [expandedFacility, setExpandedFacility] = useState(null);

  const totalPages = Math.ceil(filteredMerchants.length / merchantsPerPage);

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const docRef = collection(db, "merchants");
        const querySnapshot = await getDocs(docRef);
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        const docRefFacility = collection(db, "facility");
        const querySnapshotFacility = await getDocs(docRefFacility);
        const dataFacility = querySnapshotFacility.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        console.log("Facility", dataFacility);

        const facilitiesByMerchant = {};
        dataFacility.forEach((facility) => {
          const merchantId = facility.merchant_id;

          if (!facilitiesByMerchant[merchantId]) {
            facilitiesByMerchant[merchantId] = [];
          }
          facilitiesByMerchant[merchantId].push(facility);
        });

        // Associate facilities with merchants in the 'data' array
        data.forEach((merchant) => {
          const merchantId = merchant.id;

          if (facilitiesByMerchant[merchantId]) {
            merchant.facilities = facilitiesByMerchant[merchantId];
          } else {
            // If a merchant has no facilities, set an empty array for clarity
            merchant.facilities = [];
          }
          console.log(merchant.facilities.length);
        });

        console.log("Merchant", data);

        setMerchants(data);
        setFilteredMerchants(data);

        // Set up a real-time listener for changes
        unsubscribe = onSnapshot(docRef, (snapshot) => {
          const updatedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          console.log("Real time update merchant");
          updatedData.forEach((merchant) => {
            const merchantId = merchant.id;

            if (facilitiesByMerchant[merchantId]) {
              merchant.facilities = facilitiesByMerchant[merchantId];
            } else {
              // If a merchant has no facilities, set an empty array for clarity
              merchant.facilities = [];
            }
            console.log(merchant.facilities.length);
          });
          setMerchants(updatedData);
          setFilteredMerchants(updatedData);
        });
      } catch (error) {
        console.error("Error fetching merchants: ", error);
      }
    };

    fetchUsers();

    return () => {
      // Unsubscribe from the listener when component unmounts
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);

  const handleSearchMerchantName = (event) => {
    const searchMerchantName = event.target.value.toLowerCase();
    setSearchMerchantName(searchMerchantName);
    filterAndSortMerchants(searchMerchantName, searchMerchantEmail, sortType);
  };

  const handleSearchMerchantEmail = (event) => {
    const searchMerchantEmail = event.target.value.toLowerCase();
    setSearchMerchantEmail(searchMerchantEmail);
    filterAndSortMerchants(searchMerchantName, searchMerchantEmail, sortType);
  };

  //   const handleFilterType = (event) => {
  //     const type = event.target.value;
  //     setFilterType(type);
  //     filterAndSortMerchants(searchMerchantName, searchMerchantEmail, type, sortType);
  //   };

  const handleSortNoOfFacility = () => {
    const newSortType = sortType === "asc" ? "desc" : "asc";
    setSortType(newSortType);
    filterAndSortMerchants(
      searchMerchantName,
      searchMerchantEmail,
      newSortType
    );
  };

  const filterAndSortMerchants = (searchMerchant, searchEmail, sort) => {
    let filtered = merchants;

    filtered = filtered.filter((merchant) =>
      merchant.name.toLowerCase().includes(searchMerchant)
    );

    console.log(searchEmail);

    filtered = filtered.filter((merchant) => {
      if (merchant.email && typeof merchant.email === "string") {
        return merchant.email.toLowerCase().includes(searchEmail);
      }
      return true;
    });

    filtered.sort((a, b) => {
      if (sort === "asc") {
        return a.facilities.length - b.facilities.length;
      } else {
        return b.facilities.length - a.facilities.length;
      }
    });

    setFilteredMerchants(filtered);
  };

  const showUserDetails = (facility) => {
    setSelectedMerchantDetails(facility);
    setShowModal(true);
    setShownDescription("");
    // let tempDes = "";
    // if (facility.isCustomDescription) {
    //   facility.description.forEach((element) => {
    //     if (element !== "Others") {
    //       tempDes = tempDes + element + ", ";
    //     }
    //   });
    //   tempDes += facility.customDescription;
    // } else {
    //   facility.description.forEach((element) => {
    //     tempDes = tempDes + element + ", ";
    //   });
    //   tempDes = tempDes.substring(0, tempDes.length - 2);
    // }
    // setShownDescription(tempDes);
  };

  const handleDelete = async (id, name) => {
    // Show confirmation dialog
    setMerchantNameToDelete(name);
    setMerchantToDelete(id);
    setShowConfirmation(true);
  };

  const confirmDelete = async () => {
    try {
      await deleteDoc(doc(db, "merchants", merchantToDelete));
      //delete the facility
      const q = query(
        collection(db, "facility"),
        where("merchant_id", "==", merchantToDelete)
      );
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        deleteDoc(doc.ref)
          .then(() => {
            console.log("Document successfully deleted!");
          })
          .catch((error) => {
            console.error("Error removing document: ", error);
          });
      });
      
      // //delete the user from authentication
      // const auth = getAuth();
      // auth.deleteUser(merchantToDelete)
      // .then(() => {
      //   console.log('User deleted successfully.');
      // })
      // .catch((error) => {
      //   console.error('Error deleting user:', error);
      // });

      const updatedUsers = merchants.filter(
        (merchant) => merchant.id !== merchantToDelete
      );
      console.log("Delete User", merchantToDelete);
      setMerchants(updatedUsers);
      setShowConfirmation(false); // Close confirmation dialog after delete
    } catch (error) {
      console.error("Error deleting merchant: ", error);
    }
  };

  const editUser = (merchant) => {
    setEditingMerchant(merchant);
    setShowEditModal(true);
    setName(merchant.name);
    setContact(merchant.contact);
    setEmail(merchant.email);
  };

  const handleCloseEditModal = () => {
    setEditingMerchant(null);
    setShowEditModal(false);
    setError("")
  };

  async function handleEdit(e) {
    setError("");
    e.preventDefault();
    if (!nameRef.current.value) {
      setLoading(false);
      return setError("Name should not be empty");
    }

    if (!contactRef.current.value) {
      setLoading(false);
      return setError("Contact should not be empty");
    }

    if (!validateContactNumber(contactRef.current.value)) {
      setError("Contact number must be at least 8 digits");
      setLoading(false);
      return;
    }

    if (
      !(await updateMerchant(nameRef.current.value, contactRef.current.value))
    ) {
      setLoading(false);
      return setError("Error in updating merchant, please try again");
    }

    setLoading(false);
    setShowSuccessModal(true);
    setShowEditModal(false);
  }

  function validateContactNumber(contact) {
    // Regular expression to match a number with a minimum length of 8 digits
    const contactRegex = /^\d{8,}$/;
    return contactRegex.test(contact);
  }

  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const updateMerchant = async (name, contact) => {
    console.log("User name and contact", name, contact);
    try {
      console.log(editingMerchant.id);
      const userRef = doc(db, "merchants", editingMerchant.id);
      await updateDoc(userRef, {
        name: name,
        contact: contact,
      });
      console.log("Update User successfully!");

      return true;
    } catch (error) {
      console.error("Error updating profile:", error);
      return false;
      // Handle error: For example, display an error message to the merchant
    }
  };


  const getDescription = (facility) => {
    let tempDes = "";
    if (facility.isCustomDescription) {
      facility.description.forEach((element) => {
        if (element !== "Others") {
          tempDes = tempDes + element + ", ";
        }
      });
      tempDes += facility.customDescription;
    } else {
      facility.description.forEach((element) => {
        tempDes = tempDes + element + ", ";
      });
      tempDes = tempDes.substring(0, tempDes.length - 2);
    }

    return tempDes;
  };


  return (
    <div>
      <div className="table-responsive px-5 my-1 mt-3 mt-sm-2 pt-1">
        <div className="row mb-3">
          <div className="col-md-3">
            <input
              type="text"
              placeholder="Search by merchant name..."
              value={searchMerchantName}
              onChange={handleSearchMerchantName}
              className="form-control"
            />
          </div>
          <div className="col-md-3 mt-3 mt-md-0">
            <input
              type="text"
              placeholder="Search by merchant email..."
              value={searchMerchantEmail}
              onChange={handleSearchMerchantEmail}
              className="form-control"
            />
          </div>
          {/* <div className="col-md-3 mt-3 mt-md-0">
            <select onChange={handleFilterType} className="form-select">
              <option value="">All Types</option>
              <option value="Toilet">Toilet</option>
              <option value="Rest">Rest</option>
              <option value="Other">Other</option>
            </select>
          </div> */}
          <div className="col-md-3 mt-3 mt-md-0">
            <button onClick={handleSortNoOfFacility} className="btn custom-button">
              Sort by No of Facility (
              {sortType === "asc" ? "Ascending" : "Descending"})
            </button>
          </div>
        </div>
        <table className="table mt-3 mt-md-0">
          <thead>
            <tr className="custom-trow">
              <th className="custom-thead">Merchant</th>
              <th className="custom-thead">Email</th>
              <th className="custom-thead">Contact</th>
              <th className="custom-thead">No of Facility</th>
              <th className="custom-thead">Action</th>
              <th className="custom-thead"></th>
            </tr>
          </thead>
          <tbody>
            {merchantsToShow.map((merchant) => (
              <tr className="custom-trow" key={merchant.id}>
                <td data-label="User" className="name-column">
                  {merchant.name}
                </td>
                <td data-label="Email" className="email-column">
                  {merchant.email}
                </td>
                <td data-label="Contact " className="contact-column">
                  {merchant.contact}
                </td>
                <td data-label="No of Facility" className="login-column">
                  {console.log("fkwdjfik", merchant.facilities)}
                  {!!merchant.facilities && merchant.facilities.length}
                </td>
                <td data-label="Action">
                  <i
                    className="bi bi-pencil-fill edit-icon mx-2 fs-4"
                    onClick={() => editUser(merchant)}
                  ></i>
                  <i
                    className="bi bi-trash-fill trash-icon mx-2 fs-4"
                    onClick={() => handleDelete(merchant.id, merchant.name)}
                  ></i>
                </td>
                <td>
                  <Button
                    id="button-active"
                    className="custom-button"
                    onClick={() => showUserDetails(merchant)}
                  >
                    View
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="d-flex justify-content-end align-items-center mt-3">
          <div className="justify-content-center">
            <h6 className="me-3" style={{ color: "grey", fontSize: "15px" }}>
              {currentPage} of {totalPages > 0 ? totalPages : 1} pages
            </h6>
          </div>
          <button
            className="btn custom-button me-2"
            onClick={prevPage}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <button
            className="btn custom-button "
            onClick={nextPage}
            disabled={currentPage === totalPages || totalPages==0}
          >
            Next
          </button>
        </div>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Merchant Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Display selected facility details */}
          {selectedMerchantDetails && (
            <div>
              <p className="my-1">
                <strong>Name</strong>: {selectedMerchantDetails.name}
              </p>
              <p className="my-1">
                <strong>Email</strong>: {selectedMerchantDetails.email}
              </p>
              <p className="my-1">
                <strong>Contact</strong>: {selectedMerchantDetails.contact}
              </p>
              <p className="my-1">
                <strong>Address</strong>: {selectedMerchantDetails.address}
              </p>
              <p className="my-1">
                <strong>No of Facilities</strong>:{" "}
                {selectedMerchantDetails.facilities.length}
              </p>

              {selectedMerchantDetails.facilities.map((facility, index) => (
                <div key={index} className="facility-div">
                  <div
                    className="facility-header mt-2 "
                    onClick={() =>
                      setExpandedFacility(
                        expandedFacility === index ? null : index
                      )
                    }
                  >
                    {/* Add an arrow icon to indicate the expand/collapse */}
                    <i
                      className={`bi ${
                        expandedFacility === index
                          ? "bi-chevron-up"
                          : "bi-chevron-down"
                      }`}
                    ></i>
                    <span className="ms-2">{facility.facilityName}</span>
                  </div>
                  {expandedFacility === index && (
                    <div className="facility-details">
                      <p>Type: {facility.type}</p>
                      <p>Location: {facility.location}</p>
                      <p>Rating: {facility.rating}</p>
                      <p>Description: {getDescription(facility)}</p>
                      {/* Display other facility details here */}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="button-active"
            className="custom-button"
            onClick={() => setShowModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showConfirmation} onHide={() => setShowConfirmation(false)}>
        <Modal.Header closeButton>
          <i className="bi bi-trash-fill fs-4 me-2"></i>
          <Modal.Title className="fs-4">Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body className="mt-4 d-flex flex-column align-items-center justify-content-center">
          Are you sure to delete merchant:{" "}
          <p className="name">{merchantNameToDelete}</p>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between mt-4">
          <Button
            id="button-active"
            className="custom-button"
            onClick={confirmDelete}
          >
            Confirm
          </Button>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmation(false)}
            className="cancel-button"
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showEditModal} onHide={handleCloseEditModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            {" "}
            <i className="bi bi-pencil-fill edit-icon mx-2 fs-4"></i>Edit User
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Form to edit merchant details */}
          {editingMerchant && (
            <div>
              <Form className="custom-form" onSubmit={handleEdit}>
                <Form.Group className="mt-1" id="name">
                  <Form.Label className="custom-label mb-0">Name</Form.Label>
                  <Form.Control
                    className="custom-input"
                    type="text"
                    ref={nameRef}
                    value={name && name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="mt-1" id="email">
                  <Form.Label className="custom-label mb-0">Email</Form.Label>
                  <Form.Control
                    className="custom-input"
                    type="email"
                    ref={emailRef}
                    value={email && email}
                    disabled={true}
                  />
                </Form.Group>

                <Form.Group className="mt-1" id="contact">
                  <Form.Label className="custom-label mb-0">Contact</Form.Label>
                  <Form.Control
                    className="custom-input"
                    type="tel"
                    ref={contactRef}
                    value={contact && contact}
                    onChange={(e) => setContact(e.target.value)}
                  />
                </Form.Group>
              </Form>
            </div>
          )}

          {error && <Alert variant="danger mt-2">{error}</Alert>}
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between mt-4">
          <Button
            className="custom-button"
            onClick={handleEdit}
            disabled={loading}
          >
            Confirm
          </Button>
          <Button
            variant="secondary"
            onClick={handleCloseEditModal}
            className="cancel-button"
            disabled={loading}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showSuccessModal} onHide={handleCloseSuccessModal}>
        <Modal.Header closeButton>
          <Modal.Title>Success!</Modal.Title>
        </Modal.Header>
        <Modal.Body>User has been successfully updated.</Modal.Body>
        <Modal.Footer>
          <Button id="customBtn" onClick={handleCloseSuccessModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
